// extracted by mini-css-extract-plugin
export default {"reportsContainer":"QdKVm","accordianStyle":"l_ee7","newReportHeading":"Jm4aO","contentIcon":"FrEsg","newReport":"x5VpG","hoverState":"sU2xc","deleteReport":"ivosu"};